import axios from 'axios';
import _ from 'lodash';

import { APPLICATION_HEADERS, API_URLS } from '../../models/headers';
import {
  reorderData,
  sendHttpRequest,
  formatDatefromTimeStamp,
  getCurrentLocationCoordinates,
  getAfterSevenDaysTimeStamp,
  strToArray,
} from '../../utils/utils';
import store from '../store';

export const providerAction = (surveyId, shortListed, allOptions) => {
  let isBrokerStrPresent = false;

  if (window.location.href.indexOf('broker') > -1) {
    isBrokerStrPresent = true;
  }

  return function providerActionDispatch(dispatch) {
    if (surveyId) {
      const reqObj = {
        id: surveyId,
      };

      dispatch({ type: 'SET_API_LOADING', set: true });

      const optionURL = API_URLS.getBubbleSurveysURL;

      axios
        .post(optionURL, reqObj, { headers: APPLICATION_HEADERS.dealHeaders })
        .then(async (res) => {
          let allOptionsData = res?.data?.optionProviderRequestList;

          const responseData = res.data;

          allOptionsData = allOptionsData.map((obj) => {
            if (obj?.shortlistedOrder > 0) {
              obj.shortListed = true;
            }

            return obj;
          });

          if (!isBrokerStrPresent) {
            allOptionsData = allOptionsData.filter((obj) => obj.includeOnClientDeliverable);
          }

          responseData.optionProviderRequestList = [...allOptionsData];

          if (allOptionsData) {
            dispatch({ type: 'SET_API_LOADING', set: false });

            allOptionsData.map((option) => {
              option.tourRequestedDate = strToArray(option.tourRequestedDate);

              if (option.tourScheduledDate) {
                const sevenDaysFromNow = getAfterSevenDaysTimeStamp(
                  formatDatefromTimeStamp(option.tourScheduledDate, 'MMM DD, YYYY'),
                );

                if (sevenDaysFromNow < new Date().getTime()) {
                  option.tourCompleted = true;
                }
              }
            });

            let i = 0;

            if (!isBrokerStrPresent) {
              for (const o of allOptionsData) {
                o.ID = i + 1;
                if (o.address) {
                  if (o.coordinates && o.coordinates?.Latitude && o.coordinates?.Longitude) {
                    const updatedAddress = {
                      address: o.address,
                      lat: o.coordinates?.Latitude,
                      lng: o.coordinates?.Longitude,
                    };

                    o.address = updatedAddress;
                  } else {
                    try {
                      const response = await getCurrentLocationCoordinates(o.address);

                      if (response) {
                        const coordinates = response.data.results[0].geometry.location;

                        o.address = {
                          address: o.address,
                          lat: coordinates.lat,
                          lng: coordinates.lng,
                        };
                      }
                    } catch (e) {
                      console.log(e);
                    }
                  }
                }
                i++;
              }
            }

            dispatch({
              type: 'SET_ORIGINAL_OPTIONS',
              options: allOptionsData,
            });

            const shortlistArrayIds = allOptionsData
              .filter((obj) => obj?.shortListed === true)
              .map((obj) => obj.id);

            if (shortlistArrayIds && shortlistArrayIds.length > 0) {
              dispatch({ type: 'SET_SHORTLIST_IDS', ids: shortlistArrayIds });
              const [shortlistedOptions, options] = reorderData(shortlistArrayIds, allOptionsData);

              dispatch({
                type: 'SET_SHORTLIST_DATA',
                shortlistedOptions: shortlistedOptions,
              });
              responseData.options = options;

              if (shortListed || shortListed === 'true') {
                responseData.optionProviderRequestList = shortlistedOptions;
                dispatch({
                  type: 'SET_ORIGINAL_OPTIONS',
                  options: shortListed,
                });
                dispatch({ type: 'SET_OPTIONS_DATA_PDF', set: true });
              }
            }
            _.orderBy(responseData, 'Order', 'asc');
            dispatch({ type: 'SET_DATA', options: responseData });
            dispatch({ type: 'SET_API_LOADING', set: false });
          } else {
            dispatch({ type: 'SET_DATA', options: [] });
            dispatch({ type: 'SET_API_LOADING', set: false });
          }
        })
        .catch((error) => {
          console.log('error page ', error);
          console.log(error.response);
          if (error.response) {
            console.log(error);
          } else {
            providerActionDispatch(dispatch);
          }
        });
    } else {
      console.log('NO ID PASSED');
    }
  };
};

// Action creator for handling flexpert email
export const flexpertEmailAction = (id, userType) => async (dispatch) => {
  const dealId = id;

  const headers = APPLICATION_HEADERS.getDealURLHeaders;

  // If dealId is falsy (null, undefined, 0, "", etc.), return early
  if (!dealId) {
    return;
  }

  const url = `${API_URLS.getDealURL}?dealId=${dealId}`;

  try {
    const { data } = await axios.get(url, { headers });

    // If data, records or the first element in records are falsy, return early
    if (!data?.records?.length) {
      return;
    }

    // Destructure the first record to get fields
    const { fields } = data.records[0];

    // If fields object is undefined or empty, stop execution
    if (!fields || typeof fields !== 'object' || Object.keys(fields).length === 0) {
      return;
    }

    // Destructure fields to get the various properties
    const {
      'Flexpert Email': mails,
      'Client Current Location': currentLocation,
      'Provider form - cc flexpert?': cc_email,
      'Shortlisted Provider': shortlisted_provider,
      'Shortlisted Provider Contact': shortlisted_provider_contact,
      'Survey View Counter': surveyViewCounter,
      'PDF View Counter': pdfViewCounter,
      'Shortlist View Counter': shortlistViewCounter,
      'Request for tour counter': tourCounter,
      'Tour requested date': tourReqDate,
      'Edit Client Deliverable counter': localBrokerCounter,
    } = fields;

    // Only dispatch the action if value is not undefined or null
    dispatch({ type: 'SET_DEAL_ID', dealId });
    dispatch({ type: 'SET_CURRENT_DEAL', currentDeal: fields });
    if (shortlistViewCounter)
      dispatch({ type: 'SET_SHORTLIST_VIEW_COUNTER', shortlistViewCounter });
    if (tourCounter) dispatch({ type: 'SET_REQUEST_TOUR_VIEW_COUNTER', tourCounter });
    if (pdfViewCounter) dispatch({ type: 'SET_PDF_VIEW_COUNTER', pdfViewCounter });
    if (currentLocation) dispatch({ type: 'SET_CURRENT_LOCATION', currentLocation });
    if (tourReqDate) dispatch({ type: 'SET_TOUR_REQ_DATE', tourReqDate });
    if (mails) dispatch({ type: 'SET_FLEXPERTS_EMAIL', emails: mails });
    if (cc_email) dispatch({ type: 'SET_CC_EMAIL', ccmails: cc_email });
    if (shortlisted_provider)
      dispatch({
        type: 'SET_SHORTLISTED_PROVIDER',
        shortlistedProvider: shortlisted_provider,
      });
    if (shortlisted_provider_contact)
      dispatch({
        type: 'SET_SHORTLISTED_PROVIDER_CONTACT',
        shortlistedProvidercontact: shortlisted_provider_contact,
      });
    if (localBrokerCounter)
      dispatch({
        type: 'SET_LOCAL_BROKER_COUNTER',
        editClientDeliverableCounter: localBrokerCounter,
      });

    // If userType is 'CLIENT', update the view counter
    if (userType?.trim() === 'CLIENT') {
      updateViewCounter(dealId, surveyViewCounter);
    }
  } catch (error) {
    console.error(error);
  }
};

export const majorProviders = () => async (dispatch) => {
  const majorProvidersURL = API_URLS.majorProvidersURL;

  axios
    .get(majorProvidersURL, { headers: APPLICATION_HEADERS.majorProvidersHeaders })
    .then((res) => {
      if (res && res.status === 200) {
        dispatch({
          type: 'SET_MAJOR_PROVIDERS',
          majorProviders: res?.data?.list,
        });
      }
    });
};

export const scheduleTour = (selectedPropertiesForTour) => {
  return function scheduleTourDispatch(dispatch) {
    const optionURL = API_URLS.updateBubbleOptionURL;

    const map = new Map();

    selectedPropertiesForTour.forEach((property) =>
      map.set(property.id, property.tourRequestedDate),
    );
    const state = store.getState();
    const options = state.optRed.data.options;

    const reqListObj = {
      list: selectedPropertiesForTour,
    };

    dispatch({ type: 'SET_SHOW_LOADING', loading: true });
    axios
      .put(optionURL, reqListObj, { headers: APPLICATION_HEADERS.dealHeaders })
      .then((res) => {
        if (res && res.status === 200) {
          const newOptions = options.map((option) => {
            if (map.has(option.id)) {
              option.tourRequestedDate = map.get(option.id);
            }

            return option;
          });

          dispatch({ type: 'SET_REQUESTED_TOUR', payload: map });
          dispatch({ type: 'SET_SHOW_LOADING', loading: false });
          dispatch({ type: 'SET_TOUR_REQUEST', isSuccess: true });
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error);
        } else {
          scheduleTourDispatch(dispatch);
        }
      });
  };
};

export const updateLocation = (location) => {
  return async function (dispatch) {
    const state = store.getState();
    const dealId = state.comRed.dealId;
    const dealURL = API_URLS.updateDealURL;

    const reqObj = { dealId: dealId, clientCurrentLocation: location ?? '' };

    dispatch({ type: 'SET_CURRENT_LOCATION', currentLocation: location });
    const resp = await sendHttpRequest(dealURL, 'put', reqObj);

    if (resp?.status === 200) {
      console.log('location updated');
    } else {
      const resp = await sendHttpRequest(dealURL, 'put', reqObj);
    }
  };
};

export const updateCounter = (sf, counterName) => {
  return function (dispatch) {
    const state = store.getState();
    const dealID = state.comRed.dealId;
    const counter = state.comRed[counterName];

    // if (counterName === 'editClientDeliverableCounter') {
    //   counter = counter + 1;
    // }
    updateViewCounter(dealID, counter, counterName);
    if (counterName === 'shortlistViewCounter') {
      dispatch({
        type: 'SET_SHORTLIST_VIEW_COUNTER',
        shortlistViewCounter: counter + 1,
      });
    }
  };
};
const updateDEALInfo = (url, obj, headers) => {
  axios
    .put(url, obj, { headers })
    .then((res) => {
      if (res && res.status === 200) {
        //successs call
      } else {
        //    failure call
        console.log('failure');
      }
    })
    .catch((error) => {
      console.log('error');
      if (error.response) {
        console.log(error);
      } else {
        updateDEALInfo(url, obj, headers);
      }
    });
};
const updateViewCounter = (dealID, scounter, counterName) => {
  if (dealID) {
    const counter = scounter ? scounter : 0;
    const reqObj = { dealId: dealID };

    if (counterName) {
      reqObj[counterName] = 1;

      if (counterName == 'tourCounter') {
        const state = store.getState();
        const tour_req_date = state.comRed.tourReqDate;

        if (!tour_req_date) {
          reqObj['stage'] = 'Tour';
          reqObj['tourReqDt'] = formatDatefromTimeStamp(new Date(), 'MM/DD/YYYY');
        }
      }
    } else {
      reqObj['surveyViewCounter'] = counter + 1;
    }

    //api calling to update
    const dealURL = API_URLS.updateDealURL;

    updateDEALInfo(dealURL, reqObj, APPLICATION_HEADERS.dealHeaders);
  }
};

export const locationAction = (locations) => {
  return {
    type: 'SET_LOCATIONS',
    locations,
  };
};

const getAllOptionsData = async (o) => {
  if (!o.address && o.addressBackup) {
    const response = await getCurrentLocationCoordinates(o.addressBackup);

    if (response) {
      const coordinates = response.data.results[0].geometry.location;

      o.address = {
        address: o.addressBackup,
        lat: coordinates.lat,
        lng: coordinates.lng,
      };
    }
  }

  return o;
};

export const providerPreviewAction = (optionId) => {
  return function (dispatch) {
    if (optionId) {
      const reqObj = {
        id: optionId,
      };

      const optionURL = API_URLS.getProviderOptionURL;

      axios
        .post(optionURL, reqObj, { headers: APPLICATION_HEADERS.dealHeaders })
        .then(async (res) => {
          if (res.data) {
            let data = res.data;

            data.ID = 1;
            data = await getAllOptionsData(data);
            dispatch({ type: 'SET_DATA', options: data });
          } else {
            dispatch({ type: 'SET_DATA', options: [] });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      console.log('NO ID PASSED');
    }
  };
};

export const setPDFViewAction = (isPdf) => {
  return function (dispatch) {
    dispatch({ type: 'SET_PDF_DOWNLOAD', pdfDownload: isPdf });
  };
};

export const setOptionDataPDF = (isOption) => {
  return function (dispatch) {
    dispatch({ type: 'SET_OPTIONS_DATA_PDF', set: isOption });
  };
};

export const reoderBrokerOptions = (options) => ({
  type: 'REORDER_BROKER_OPTIONS',
  payload: options,
});
